(function () {
  var CODE_ATTR = '_raf_code';
  var NAME_ATTR = '_raf_advocate_name';
  var CODE_STORAGE = 'raf_code';
  var NAME_STORAGE = 'raf_advocate_name';
  var SET_AT_STORAGE = 'raf_code_set_at';
  var CODE_PATTERN = /^[A-Z]{4}\d{4}$/;
  /* Matches the 14-day Shopify-refunds wait window in the RAF architecture —
     anything older has either been credited or lapsed. */
  var TTL_MS = 14 * 24 * 60 * 60 * 1000;

  function safeGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function safeSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) {}
  }
  function safeRemove(key) {
    try { localStorage.removeItem(key); } catch (e) {}
  }
  function clearReferralStorage() {
    safeRemove(CODE_STORAGE);
    safeRemove(NAME_STORAGE);
    safeRemove(SET_AT_STORAGE);
  }

  /* Order-status page short-circuit. Dormant on theme pages — only fires
     when this script is wired into Shopify's checkout Additional Scripts. */
  if (window.Shopify && window.Shopify.Checkout && window.Shopify.Checkout.OrderStatus) {
    clearReferralStorage();
    return;
  }

  /* TTL sweep on every theme page load. Backfills a timestamp for users who
     stored a code before this code shipped, so the TTL eventually applies. */
  var existingCode = safeGet(CODE_STORAGE);
  var setAt = parseInt(safeGet(SET_AT_STORAGE), 10);
  if (existingCode && !setAt) {
    safeSet(SET_AT_STORAGE, Date.now().toString());
  } else if (setAt && (Date.now() - setAt) > TTL_MS) {
    clearReferralStorage();
  }

  function renderAdvocateName(name) {
    if (!name || typeof document === 'undefined') return;
    var slots = document.querySelectorAll('.raf-advocate-name');
    for (var i = 0; i < slots.length; i++) {
      slots[i].textContent = name;
    }
  }

  function renderCode(code) {
    if (!code || typeof document === 'undefined') return;
    var slots = document.querySelectorAll('.raf-code');
    for (var i = 0; i < slots.length; i++) {
      slots[i].textContent = code;
    }
  }

  var prevCode = safeGet(CODE_STORAGE);
  var params = new URLSearchParams(window.location.search);
  var urlCode = params.get('ref');

  if (urlCode) {
    var normalized = urlCode.toUpperCase().trim();
    if (CODE_PATTERN.test(normalized)) {
      safeSet(CODE_STORAGE, normalized);
      safeSet(SET_AT_STORAGE, Date.now().toString());
      if (normalized !== prevCode) {
        safeRemove(NAME_STORAGE);
        fetch('/apps/raf/advocate-name?code=' + encodeURIComponent(normalized), {
          headers: { 'Accept': 'application/json' },
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (body) {
            if (body && typeof body.first_name === 'string' && body.first_name.length) {
              safeSet(NAME_STORAGE, body.first_name);
              renderAdvocateName(body.first_name);
            }
          })
          .catch(function () {});
      }
    }
  }

  var storedCode = safeGet(CODE_STORAGE);
  if (!storedCode || !CODE_PATTERN.test(storedCode)) return;

  renderCode(storedCode);

  var storedName = safeGet(NAME_STORAGE);
  if (storedName) renderAdvocateName(storedName);

  var attrs = {};
  attrs[CODE_ATTR] = storedCode;
  if (storedName) attrs[NAME_ATTR] = storedName;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify({ attributes: attrs }),
  }).catch(function () {});
})();
